import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import './members.scss';
import { useSelector, shallowEqual } from 'react-redux';
import ReactGA from 'react-ga4';

import CustomButton from "../../uiKit/Button/CustomButton";
import MobileList from "./mobileList";
import MemberSearchInput from "./memberSearchInput";
import MembersTable from "./membersTable";

const Members = () => {

    const history = useHistory();
    const { pathname } = useLocation()

    const membersCount = useSelector(state => state.community.community.numberOfMembers, shallowEqual);
    const screenWidth = useSelector(state => state.common.screenWidth, shallowEqual);

    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: `/members` })
    }, [])

    const navigateAddMember = () => {
        history.push(`${pathname}/add-members`)
    }

    return (
        <>
            <div className='membersList'>
                <MemberSearchInput totalMembers={membersCount} />
                {
                    screenWidth < 1200 && (
                        <div className='memberButton'>
                            <CustomButton
                                title={'Add Member'}
                                onClick={navigateAddMember}
                                style={{ marginTop: '16px' }}
                            />
                        </div>
                    )
                }
                {
                    screenWidth <= 1200 && (
                        <div className='listMobile'>
                            <MobileList />
                        </div>
                    )
                }
                {
                    screenWidth >= 1200 && (
                        <div className='memberButton'>
                            <CustomButton
                                title={'Add Member'}
                                onClick={navigateAddMember}
                            />
                        </div>
                    )
                }
            </div>
            <MembersTable />
        </>
    )
}

export default Members;